import { FC } from "react";
import { useIntl } from "react-intl";
import { Box, Typography } from "@mui/material";

import { useAlarmPaletteResolver } from "../../../../hooks/use-alarm-color";
import type { IStationTrainDefectIcon } from "../scheme/views/station-scheme/components/station-train/interfaces";
import { STATION_DEFECT_ICON_SRCS } from "../scheme/views/station-scheme/components/station-train/station-defect-icon-assets";

export const ForecastingDefectIcons: FC<{
  icons: IStationTrainDefectIcon[];
  label: string;
}> = ({ icons, label }) => {
  const { formatMessage } = useIntl();
  const resolveAlarmColor = useAlarmPaletteResolver();

  return (
    <Box
      component="fieldset"
      sx={{
        m: 0,
        p: 1,
        minWidth: 0,
        flex: "1 1 150px",
        alignSelf: "stretch",
        border: "1px solid #a8adbf",
        borderRadius: "6px",
      }}
    >
      <Typography
        component="legend"
        sx={{ px: 0.5, fontSize: 14, lineHeight: "18px", minHeight: 36, color: "#4b5161" }}
      >
        {label}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 0.5, minHeight: 44 }}>
        {icons.length ? (
          icons.map(icon => {
            const title = `${formatMessage({
              id: `pages.scheme.stationTile.defectIcons.${icon.type}`,
            })}: ${formatMessage({
              id: `enums.alarms.${icon.alarmStatus}`,
              defaultMessage: String(icon.alarmStatus),
            })}`;

            return (
              <Box
                key={icon.type}
                role="img"
                aria-label={title}
                title={title}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 48,
                  height: 44,
                  border: "1px solid #8e8e8e",
                  borderRadius: "3px",
                  backgroundColor: "#d9d9d9",
                }}
              >
                <Box
                  component="img"
                  src={STATION_DEFECT_ICON_SRCS[icon.type]}
                  alt=""
                  aria-hidden="true"
                  sx={{
                    width: "88%",
                    height: "88%",
                    objectFit: "contain",
                    backgroundColor: resolveAlarmColor(icon.alarmStatus),
                  }}
                />
              </Box>
            );
          })
        ) : (
          <Typography sx={{ fontSize: 16, color: "#4b5161", opacity: 0.5 }}>
            {formatMessage({ id: "pages.forecasting.summary.noDefects" })}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
